/**
 * Tailwind CSS breakpoints
 * @see https://tailwindcss.com/docs/responsive-design
 */
export const BREAKPOINTS = {
  xs: '480px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
} as const;

/**
 * Media query strings for breakpoints
 * Use with window.matchMedia() or useMediaQuery hook
 */
export const BREAKPOINT_QUERIES: Record<Breakpoint, string> = {
  xs: '(min-width: 480px)',
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  '2xl': '(min-width: 1536px)',
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;
